import React, { FC } from "react"
import { Stack, Card, HStack, Divider, Button, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import HeadingSection from "../../components/HeadingSection";

const SectionsSummary: FC = () => (
  <Stack>
    <Card p={4} mb={2} variant='outline'>
      <HStack justify='space-between'>
        <HeadingSection title='Division municipal' subtitle='Guaymas' />
        <HeadingSection title='Distrito electoral' subtitle='13' />
        <HeadingSection title='Secciones' subtitle='91' />
        <HeadingSection title='Lista nominal' subtitle='119,875' />
        <HeadingSection title='Padrón electoral' subtitle='120,839' />
        <HeadingSection title='Última actualización' subtitle='02 de Junio 2023' />
      </HStack>
      <Divider mb={2} />
      <HStack justify='space-between'>
        <Text
          fontSize='xs'
          fontWeight='medium'
          color='gray.500'
        >
          Fuente: INE
        </Text>
        <Button
          size='sm'
          as={Link}
          variant='ghost'
          // colorScheme='brand'
          textColor='brand.500'
          to='http://www.ieesonora.org.mx/documentos/estadistica_cartografia/municipal/GUAYMAS.xls'
        >
          Descargar
        </Button>
      </HStack>
    </Card>
  </Stack>
);

export default SectionsSummary
